import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";

const getAuthHeaders = () => {
  const userDetails = JSON.parse(localStorage.getItem("userDetails") || "{}");
  const token = userDetails?.idToken || "";
  return { Authorization: `Bearer ${token}` };
};

export const getDashboardStatsApi = () => {
  return axios.get(`${API_BASE_URL}/api/admin/dashboard`, {
    headers: getAuthHeaders(),
  });
};
